import CountryPageTemplate from './CountryPageTemplate';

export default function CzechiaPage() {
  return <CountryPageTemplate countryKey="cz" />;
}